<div class="p-component pb-3 border-bottom-2 border-primary">
    <h1 class="page-title m-0">{{pageTitle$ | async}}</h1>
</div>

<app-form [currentTransaction]="transaction"></app-form>

<app-unsync-transactions-list (editTransaction)="setTransaction($event)"></app-unsync-transactions-list>
<app-transactions-list (editTransaction)="setTransaction($event)"></app-transactions-list>
